import { Link } from 'react-router';
import styled from '@emotion/styled';
import ChevronLeftIcon from '@/assets/icons/chevron-right.svg?react';
import { HEADER_HEIGHT, SIDE_BAR_WIDTH } from '@/layouts/MainLayout/utils/constants';
import { Theme } from '@mui/material/styles';

export const StyledContainer = styled.div<{ theme?: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  border-top: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[500]};
  overflow: auto;

  * {
    box-sizing: border-box;
  }
`;

export const StyledNewLogoWrapper = styled.div`
  box-sizing: border-box;
  padding: 16px 8px;
  height: ${HEADER_HEIGHT};
`;

export const StyledLogoLink = styled(Link)<{ theme?: Theme }>`
  height: 100%;
  color: ${({ theme }) => theme.palette.customSecondary.primary.foreground};
  transition: color 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.primary.subtle};
  }
`;

export const StyledChevronIcon = styled(ChevronLeftIcon)`
  transform: rotate(180deg);
`;

const MENU_BUTTON_AREA_SIZE = '35px';

export const StyledCloseButton = styled.button<{ theme?: Theme }>`
  position: absolute;
  top: ${HEADER_HEIGHT};
  left: ${SIDE_BAR_WIDTH};
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[500]};
  border-radius: 50%;
  width: ${MENU_BUTTON_AREA_SIZE};
  height: ${MENU_BUTTON_AREA_SIZE};
  background-color: ${({ theme }) => theme.palette.customSecondary.background.base};
  color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
  cursor: pointer;
  opacity: 0.9;
  transition:
    background-color 0.3s,
    opacity 0.3s;

  :hover {
    background-color: ${({ theme }) => theme.palette.customSecondary.primary.DEFAULT};
    opacity: 1;
  }
`;
